export const createAsyncActionTypes = baseAction => ({
  START: `${baseAction}.START`,
  SUCCESS: `${baseAction}.SUCCESS`,
  ERROR: `${baseAction}.ERROR`,
  BASE: baseAction,
});
